import { render, staticRenderFns } from "./StudentPosterSettings.vue?vue&type=template&id=470f236c&scoped=true&"
import script from "./StudentPosterSettings.vue?vue&type=script&lang=js&"
export * from "./StudentPosterSettings.vue?vue&type=script&lang=js&"
import style0 from "./StudentPosterSettings.vue?vue&type=style&index=0&id=470f236c&lang=scss&scoped=true&"
import style1 from "./StudentPosterSettings.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f236c",
  null
  
)

export default component.exports